const indices = [
  { title: '春天恋爱特辑', desc: '10部甜到上头的韩漫恋爱作品', count: '10部精选', icon: 'ri-hearts-line' },
  { title: '热血少年漫合集', desc: '燃到停不下来的日漫经典', count: '15部精选', icon: 'ri-fire-line' },
  { title: '国漫仙侠世界', desc: '东方奇幻美学的极致呈现', count: '12部精选', icon: 'ri-magic-line' },
  { title: '深夜慎入 · 悬疑专场', desc: '熬夜也要看完的推理神作', count: '8部精选', icon: 'ri-moon-line' },
  { title: '办公室解压漫画', desc: '轻松搞笑，打工人的快乐源泉', count: '20部精选', icon: 'ri-emotion-happy-line' },
  { title: '新锐作者推荐', desc: '发现潜力无限的漫画新星', count: '6部精选', icon: 'ri-star-line' },
  { title: '完结佳作回顾', desc: '一口气读完的完整漫画', count: '18部精选', icon: 'ri-check-double-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            专题合集
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            为你精心挑选的漫画专题
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indices.slice(0, 4).map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 cursor-pointer hover:border-primary-200 transition-colors group">
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-500 mb-3">{item.desc}</p>
              <span className="text-xs text-primary-600 font-medium">{item.count}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          {indices.slice(4).map((item, i) => (
            <div key={i + 4} className="bg-background-50 rounded-xl border border-background-200/70 p-5 cursor-pointer hover:border-accent-200 transition-colors group">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                  <i className={`${item.icon} text-lg text-accent-600`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-base text-foreground-900 mb-0.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500">{item.desc}</p>
                </div>
                <span className="ml-auto text-xs text-accent-600 font-medium whitespace-nowrap">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}